import { BufOrStr, Strbuf } from '../types';
import { isDef, isStr } from '../utils/common';

/**
 * @throws should not throw
 * @param haystack
 * @param needle
 * @returns
 */
export function startsWith(haystack: BufOrStr, needle: BufOrStr): boolean {
	if (haystack.length < needle.length) {
		return false;
	}

	// Convert the needle if necessary, not the haystack (since it's bigger)
	if (isStr(haystack)) {
		needle = isStr(needle) ? needle : needle.toString('latin1');
		return haystack.startsWith(needle);
	} else {
		needle = isStr(needle) ? Buffer.from(needle, 'latin1') : needle;
		return haystack.compare(needle, 0, needle.length, 0, needle.length) === 0;
	}
}

// TODO: RDJ: Remove once no longer needed in parse-concordance-dat.ts, since doesn't
// work for UTF-16 and UTF-32
const enum Controls {
	Cr = 0x0d,
	Lf = 0x0a,
}

export function trimTrailingCrLf(buf: string): string;
export function trimTrailingCrLf(buf: Buffer): Buffer;
export function trimTrailingCrLf(buf: Strbuf): Strbuf;
export function trimTrailingCrLf(buf: Strbuf): Strbuf {
	let i;
	if (isStr(buf)) {
		const cr = String.fromCharCode(Controls.Cr);
		const lf = String.fromCharCode(Controls.Lf);
		for (i = buf.length - 1; i >= 0; --i) {
			if (buf[i] !== cr && buf[i] !== lf) {
				break;
			}
		}
	} else {
		for (i = buf.length - 1; i >= 0; --i) {
			if (buf[i] !== Controls.Cr && buf[i] !== Controls.Lf) {
				break;
			}
		}
	}

	return i === buf.length - 1 ? buf : buf.slice(0, i + 1);
}

export function trimTrailingNull(buf: string): string;
export function trimTrailingNull(buf: Buffer): Buffer;
export function trimTrailingNull(buf: Strbuf): Strbuf;
export function trimTrailingNull(buf: string | undefined): string | undefined;
export function trimTrailingNull(buf: Buffer | undefined): Buffer | undefined;
export function trimTrailingNull(buf: Strbuf | undefined): Strbuf | undefined;
export function trimTrailingNull(buf: Strbuf | undefined): Strbuf | undefined {
	if (!isDef(buf)) {
		return;
	}

	let i;
	if (isStr(buf)) {
		for (i = buf.length - 1; i >= 0; --i) {
			if (buf[i] !== '\0') {
				break;
			}
		}
	} else {
		for (i = buf.length - 1; i >= 0; --i) {
			if (buf[i] !== 0) {
				break;
			}
		}
	}

	return i === buf.length - 1 ? buf : buf.slice(0, i + 1);
}
